import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "px-2 text-gray-700" }
const _hoisted_2 = {
  key: 0,
  class: "space-y-4 leading-relaxed"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "font-bold text-gray-900 mb-4" }, "Students learn to:", -1)
const _hoisted_4 = { class: "space-y-4 leading-relaxed" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, " This helps them spell unfamiliar words by breaking them into meaningful parts and applying knowledge of spelling conventions from word origin and usage. Spelling instruction also supports writing development across the curriculum, with students expected to spell accurately in narrative, informative, and persuasive contexts. ", -1)

import { computed } from 'vue';
import LingoModalComponent from '@/modules/main/components/manage/LingoModalComponent.vue';
import { grammarLevelDescription } from '@/modules/main/utils/grammarCurriculumCopy';


export default /*#__PURE__*/_defineComponent({
  __name: 'LevelDescriptionModal',
  props: {
    isOpen: { type: Boolean },
    level: {},
    thread: {}
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props;



const grammarDescription = computed(() =>
    props.thread === 'grammar' ? grammarLevelDescription(props.level) : ''
);



function capitalise(str: string) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}

function close() {
    emit('close');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LingoModalComponent, {
    modelValue: _ctx.isOpen,
    "onUpdate:modelValue": close,
    title: `${capitalise(_ctx.thread)} Level ${_ctx.level}`,
    size: "md",
    centered: ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("button", {
        onClick: close,
        class: "w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-lg text-gray-700 font-medium hover:bg-gray-50 transition shadow-sm"
      }, " Close ")
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (grammarDescription.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("p", null, _toDisplayString(grammarDescription.value), 1)
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", null, " At Level " + _toDisplayString(_ctx.level) + ", spelling instruction deepens to focus on the structure of words — how morphemes (the smallest units of meaning) come together to form more complex words. Students study more Latin and Greek roots, as well as more advanced prefixes and suffixes. ", 1),
                _hoisted_5
              ])
            ], 64))
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})